import React from 'react';
import {
  Input, InputGroup, Label, FormGroup, FormFeedback,
} from 'reactstrap';
import classnames from 'classnames';
import Flatpickr from 'react-flatpickr';
import _ from 'lodash';
import SelectInput from 'app/components/general/SelectInput';
import InputGroupAddon from 'app/components/general/InputGroupAddon';
import NumberFormat from 'react-number-format';
import Checkbox from 'app/components/general/Checkbox';
import Phone from 'react-phone-number-input/input';

interface IInputGroupBlock {
  key: string;
  keyId: string;
  name: string;
  labelText: string;
  icon: string;
  type: string;
  autoFocus: string;
  inputGroupClassName: string;
  value: any;
  hint: any;
  placeholder: string;
  className: string;
  autoComplete: string;
  tabIndex: string;
  onChange: Function;
  onFocus: Function;
  onBlur: Function;
  readOnly: string;
  mode: string;
  clearable: boolean;
  isMulti: boolean;
  createable: boolean;
  enableTime: boolean;
  radio: boolean;
  errors: any;
  disabled: boolean;
  ref: object;
  innerRef: object;
  options: any;
}
export default class InputGroupBlock extends React.Component<IInputGroupBlock, {}> {
  static defaultProps = {
    name: undefined,
    labelText: undefined,
    icon: undefined,
    autoFocus: undefined,
    type: 'text',
    hint: undefined,
    inputGroupClassName: undefined,
    autoComplete: undefined,
    tabIndex: undefined,
    onChange: undefined,
    onBlur: undefined,
    readOnly: undefined,
    mode: undefined,
    ref: undefined,
    innerRef: undefined,
    value: undefined,
    placeholder: undefined,
    className: undefined,
    errors: undefined,
    clearable: undefined,
    createable: undefined,
    enableTime: false,
    isMulti: undefined,
    options: undefined,
    disabled: false,
    radio: false,
  };

  isInvalid = () => {
    if (!_.isEmpty(this.props.errors)) {
      if (!_.isEmpty(this.props.errors[this.props.name])) {
        return true;
      }
    }
    return false;
  };

  renderErrorFeedback = () => {
    if (
      this.props.errors !== undefined
      && !_.isEmpty(this.props.errors)
      && !_.isEmpty(this.props.errors[this.props.name])
    ) {
      if (_.isArray(this.props.errors[this.props.name])) {
        return this.props.errors[this.props.name].join(', ');
      }
      return this.props.errors[this.props.name];
    }
    return null;
  };

  render(): React.ReactNode {
    const invalid = this.isInvalid();
    if (this.props.type === 'select') {
      return (
        <div className="w-100">
          <FormGroup>
            {!_.isEmpty(this.props.labelText) && (
              <Label className="form-control-label" for={this.props.name}>
                {this.props.labelText}
              </Label>
            )}
            <div
              className={classnames(
                'select-input-group',
                this.props.inputGroupClassName,
                {
                  'is-invalid': invalid,
                },
              )}
            >
              <SelectInput
                name={this.props.name}
                id={this.props.name}
                value={this.props.value}
                icon={this.props.icon}
                invalid={invalid}
                placeholder={this.props.placeholder}
                aria-label={this.props.placeholder}
                autoFocus={this.props.autoFocus}
                onChange={this.props.onChange}
                disabled={this.props.disabled}
                clearable={this.props.clearable || false}
                isMulti={this.props.isMulti || false}
                createable={this.props.createable || false}
                options={this.props.options}
                className={this.props.className}
              />
              <FormFeedback>{this.renderErrorFeedback()}</FormFeedback>
            </div>
          </FormGroup>
        </div>
      );
    }
    if (this.props.type === 'currency') {
      return (
        <div>
          <FormGroup key={`${this.props.keyId}-fg`}>
            {!_.isEmpty(this.props.labelText) && (
              <Label className="form-control-label" for={this.props.name}>
                {this.props.labelText}
              </Label>
            )}
            <InputGroup
              key={`${this.props.keyId}-group`}
              className={classnames(this.props.inputGroupClassName, {
                disabled: this.props.disabled,
                'is-invalid': invalid,
              })}
            >
              {this.props.icon ? (
                <InputGroupAddon icon={this.props.icon} />
              ) : null}
              <NumberFormat
                key={`${this.props.keyId}-raw`}
                className={classnames(this.props.className, 'form-control')}
                value={!_.isEmpty(this.props.value) ? this.props.value : ''}
                displayType="input"
                prefix="$"
                mask="$"
                // invalid={invalid}
                placeholder={this.props.placeholder}
                // allowEmptyFormatting
                decimalScale={2}
                disabled={this.props.disabled}
                pattern="\$[\d\.,]*"
                // pattern="[\d.]*"
                fixedDecimalScale
                // type="number"
                thousandSeparator
                onValueChange={(e) => this.props.onChange(e, this.props.name, 'currency')}
                onFocus={(e) => {
                  if (this.props.onFocus !== undefined) {
                    this.props.onFocus(e, this.props.name, 'currency');
                  }
                }}
                onBlur={(e) => {
                  if (this.props.onBlur !== undefined) {
                    this.props.onBlur(e, this.props.name, 'currency');
                  }
                }}
              />
            </InputGroup>
            <FormFeedback>{this.renderErrorFeedback()}</FormFeedback>
          </FormGroup>
        </div>
      );
    }
    if (this.props.type === 'datetime') {
      return (
        <div>
          <FormGroup>
            {!_.isEmpty(this.props.labelText) && (
              <Label className="form-control-label" for={this.props.name}>
                {this.props.labelText}
              </Label>
            )}
            <InputGroup
              className={classnames(this.props.inputGroupClassName, {
                disabled: this.props.disabled,
                'is-invalid': invalid,
              })}
            >
              <Flatpickr
                className={classnames(this.props.className, 'form-control')}
                name={this.props.name}
                value={this.props.value}
                onChange={(e) => this.props.onChange(e, this.props.name, 'datetime')}
                placeholder={this.props.placeholder}
                aria-label={this.props.placeholder}
                disabled={this.props.disabled}
                // invalid={invalid}
                options={{
                  altInput: true,
                  altFormat: this.props.enableTime ? 'D j M Y - h:i K' : 'D j M Y',
                  dateFormat: 'Z',
                  static: true,
                  enableTime: this.props.enableTime || false,
                  mode: this.props.mode || 'single',
                }}
              />
            </InputGroup>
            <FormFeedback>{this.renderErrorFeedback()}</FormFeedback>
          </FormGroup>
        </div>
      );
    }
    if (this.props.type === 'phone') {
      return (
        <div>
          <FormGroup>
            {!_.isEmpty(this.props.labelText) && (
              <Label className="form-control-label" for={this.props.name}>
                {this.props.labelText}
              </Label>
            )}
            <InputGroup
              className={classnames(this.props.inputGroupClassName, {
                disabled: this.props.disabled,
                'is-invalid': invalid,
              })}
            >
              <Phone
                name="mobile"
                country="AU"
                placeholder={this.props.placeholder}
                aria-label={this.props.placeholder}
                autoComplete={this.props.autoComplete}
                tabIndex={this.props.tabIndex}
                className={`form-control ${this.props.className}`}
                value={this.props.value}
                onChange={this.props.onChange}
              />
            </InputGroup>
            <FormFeedback>{this.renderErrorFeedback()}</FormFeedback>
          </FormGroup>
        </div>
      );
    }
    if (this.props.type === 'boolean') {
      return (
        <div>
          <FormGroup>
            <Checkbox
              radio={this.props.radio}
              onClick={(e) => this.props.onChange(e, this.props.name, 'boolean')}
              checked={this.props.value || false}
            />
            {!_.isEmpty(this.props.labelText) && (
              <Label className="form-control-label" for={this.props.name}>
                {this.props.labelText}
              </Label>
            )}
            {/* <InputGroup
              className={classnames(this.props.inputGroupClassName, {
                disabled: this.props.disabled,
                'is-invalid': invalid,
              })}
            >
              <Checkbox
                onClick={(e) => this.props.onChange(e, this.props.name, 'boolean')}
                checked={this.props.value || false}
              />
            </InputGroup> */}
            <FormFeedback>{this.renderErrorFeedback()}</FormFeedback>
          </FormGroup>
        </div>
      );
    }
    return (
      <div className="w-100">
        <FormGroup>
          {!_.isEmpty(this.props.labelText) && (
            <Label className="form-control-label" for={this.props.name}>
              {this.props.labelText}
            </Label>
          )}
          {this.props.hint && (
            <div className="float-right d-inline-block text-right">
              {this.props.hint}
            </div>
          )}
          <InputGroup
            className={classnames(this.props.inputGroupClassName, {
              'is-invalid': invalid,
              disabled: this.props.disabled,
              textarea: this.props.type === 'textarea',
            })}
          >
            {this.props.icon ? (
              <InputGroupAddon icon={this.props.icon} />
            ) : null}
            <Input
              key={`${this.props.key}-input-raw`}
              type={this.props.type}
              name={this.props.name}
              id={this.props.name}
              placeholder={this.props.placeholder}
              aria-label={this.props.placeholder}
              autoFocus={this.props.autoFocus}
              invalid={invalid}
              value={!_.isEmpty(this.props.value) ? this.props.value : ''}
              autoComplete={this.props.autoComplete}
              tabIndex={this.props.tabIndex}
              onChange={this.props.onChange}
              onBlur={this.props.onBlur}
              disabled={this.props.disabled}
              className={this.props.className}
              readOnly={this.props.readOnly}
              ref={this.props.ref}
              innerRef={this.props.innerRef}
            />
          </InputGroup>
          <FormFeedback>{this.renderErrorFeedback()}</FormFeedback>
        </FormGroup>
      </div>
    );
  }
}
